/* eslint-disable max-lines */
import { faker } from '@faker-js/faker';
import type {
  ParameterSetResourceByScopeBffApi,
  ParameterSetResourceReadApi,
  ServiceConfigurationResourceVersionReadApi,
  TemplateResourceReadApi,
} from '@ingenico/api-sdk-configuration-private';
// import { enumSmartFieldTargetType } from '@ingenico/api-sdk-configuration-private';
import { generateFromEnum } from '@ingenico/api-sdk-core/mocks';
import type {
  EnumSmartFieldDataTypeApi,
  EnumSmartFieldUiComponentNoTableTypeApi,
  SchemasSmartFieldUiComponentOptionsNoTableApi,
  SmartFieldUiComponentDateTimeOptionsApi,
  SmartFieldUiComponentInputNumberOptionsApi,
  SmartFieldUiComponentInputStringOptionsApi,
  SmartFieldUiComponentMultiSelectOptionsApi,
  SmartFieldUiComponentSelectChoiceApi,
  SmartFieldUiComponentSelectOptionsApi,
  SmartFieldUiComponentToggleOptionsApi,
  TemplateDetailedResourceParameterV2Api,
  TemplateDetailedResourceReadV2Api,
  TemplateResourceParameterContainerV2Api,
  TemplateResourceParameterFieldDefinitionCommonV2Api,
  TemplateResourceParameterFieldDefinitionDynamicChoiceV2Api,
  TemplateResourceParameterFieldDefinitionStructureV2Api,
  TemplateResourceParameterFieldDefinitionV2Api,
  TemplateResourceParameterFieldRootV2Api,
  TemplateResourceParameterFieldV2Api,
  TemplateResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import {
  enumArtifactComponentType,
  enumSmartFieldDataType,
  enumSmartFieldUiComponentDateTimeType,
  enumSmartFieldUiComponentNoTableType,
  smartFieldUiComponentInputStringType,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { PathParams, HttpRequestResolverExtras, ResponseResolverInfo } from 'msw';
import { HttpResponse } from 'msw';
import {
  getFormGeneratorContainersIdByIndex,
  getFormGeneratorIdByIndex,
  getTemplateIdByIndex,
  NUMBER_FORM_GENERATOR_CONTAINERS_FIELDS,
  NUMBER_FORM_GENERATOR_FIELDS,
} from './commonUuids';

export function getTempalteByIdV2MockedResponse(): TemplateDetailedResourceReadV2Api {
  return {
    id: faker.string.uuid(),
    name: faker.lorem.word(),
    creationDate: faker.date.past(),
    componentType: faker.helpers.arrayElement(Object.values(enumArtifactComponentType)),
    createdBy: faker.string.uuid(),
    description: faker.lorem.sentence(),
    extension: faker.system.fileExt(),
    targetLocation: faker.system.filePath(),
    templateFileVersion: '1.2.0',
    templateFileName: faker.system.fileName(),
    templateFileId: faker.string.uuid(),
    checksum: faker.lorem.word(),
    fileName: faker.system.fileName(),
    mimeType: faker.system.mimeType(),
    size: faker.number.int(),
    type: faker.helpers.arrayElement(['SW_PACKAGE', 'TEMPLATE']),
    parameter: {
      containers: [],
      fields: [],
    },
  };
}

export function createTemplateV2MockedResponse() {
  return HttpResponse.json<TemplateResourceReadV2Api>({
    id: faker.string.uuid(),
    name: faker.lorem.word(),
    creationDate: faker.date.past(),
    componentType: faker.helpers.arrayElement(Object.values(enumArtifactComponentType)),
    createdBy: faker.string.uuid(),
    description: faker.lorem.sentence(),
    extension: faker.system.fileExt(),
    targetLocation: faker.system.filePath(),
    templateFileVersion: '1.2.0',
    templateFileName: faker.system.fileName(),
    templateFileId: faker.string.uuid(),
    checksum: faker.lorem.word(),
    fileName: faker.system.fileName(),
    mimeType: faker.system.mimeType(),
    size: faker.number.int(),
    type: faker.helpers.arrayElement(['SW_PACKAGE', 'TEMPLATE']),
  });
}

export function updateParameterSetByIdV1CustomHandler() {
  return HttpResponse.json<ParameterSetResourceReadApi>({
    serviceId: faker.string.uuid(),
    id: faker.string.uuid(),
    templateId: faker.string.uuid(),
    updatedBy: faker.string.uuid(),
    createdBy: faker.string.uuid(),
    updateDate: faker.date.recent(),
    creationDate: faker.date.recent(),
    values: [],
    serviceVersion: 'v1',
  });
}

export function getLatestServiceConfigurationByIdV1CustomHandler() {
  return HttpResponse.json<ServiceConfigurationResourceVersionReadApi>({
    id: '22222222-1b4d-4336-99b8-548e08b05777',
    name: 'Mocked Service',
    description: 'This is a Mocked Service.',
    serviceId: '22222222-1b4d-4336-99b8-548e08b05777',
    version: 'v2',
    releaseNote: 'New changes.',
    templates: {
      platform: {
        templateDescription: 'A templateeeeee',
        templateId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05666',
        templateName: 'A template',
      },
      device: {
        templateDescription: 'A templateeeeee',
        templateId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05666',
        templateName: 'A template',
      },
    },
  });
}

// eslint-disable-next-line max-lines-per-function
export function getLatestParameterSetsByServiceIdV1CustomHandler(
  context: ResponseResolverInfo<HttpRequestResolverExtras<PathParams>>,
) {
  return HttpResponse.json<ParameterSetResourceByScopeBffApi>({
    platform: {
      createdBy: faker.string.uuid(),
      creationDate: faker.date.recent(),
      updateDate: faker.date.recent(),
      updatedBy: faker.string.uuid(),
      serviceId: '22222222-1b4d-4336-99b8-548e08b05777',
      id: '282ac790-529f-47c4-99b2-4265a496ef40',
      templateId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05666',
      serviceVersion: 'v2',
      values: [
        {
          fieldId: 'Parameter_2',
          fieldValue: {
            single: '2',
            type: 'SINGLE',
          },
        },
        {
          fieldId: 'Services',
          fieldValue: {
            structure: [
              {
                cells: [
                  {
                    columnId: 'service_name',
                    fieldValue: {
                      single: 'Service name example 1',
                      type: 'SINGLE',
                    },
                  },
                  {
                    columnId: 'service_type',
                    fieldValue: {
                      single: 'CUSTOMER_PRESENT',
                      type: 'SINGLE',
                    },
                  },
                ],
                rowId: '1',
              },
              {
                cells: [
                  {
                    columnId: 'service_name',
                    fieldValue: {
                      single: 'Service name example 2',
                      type: 'SINGLE',
                    },
                  },
                  {
                    columnId: 'service_type',
                    fieldValue: {
                      single: 'CUSTOMER_PRESENT',
                      type: 'SINGLE',
                    },
                  },
                ],
                rowId: '2',
              },
            ],
            type: 'STRUCTURE',
          },
        },
        {
          fieldId: 'EcrConnectionConfig',
          fieldValue: {
            structure: [
              {
                cells: [
                  {
                    columnId: 'connection_name',
                    fieldValue: {
                      single: 'Connection name value',
                      type: 'SINGLE',
                    },
                  },
                  {
                    columnId: 'RefECRLink',
                    fieldValue: {
                      structure: [
                        {
                          cells: [
                            {
                              columnId: 'test_name_1',
                              fieldValue: {
                                single: 'LINK1',
                                type: 'SINGLE',
                              },
                            },
                          ],
                          rowId: 'RefECRLink-row-1',
                        },
                        {
                          cells: [
                            {
                              columnId: 'test_name_1',
                              fieldValue: {
                                single: 'LINK2',
                                type: 'SINGLE',
                              },
                            },
                            {
                              columnId: 'test_name_2',
                              fieldValue: {
                                single: 'Test name 2 value',
                                type: 'SINGLE',
                              },
                            },
                          ],
                          rowId: 'RefECRLink-row-2',
                        },
                      ],
                      type: 'STRUCTURE',
                    },
                  },
                ],
                rowId: 'RowEcrConnectionConfig1',
              },
            ],
            type: 'STRUCTURE',
          },
        },
        {
          fieldId: 'service_choices',
          fieldValue: {
            single: '["CHOICE_3"]',
            type: 'SINGLE',
          },
        },
        {
          fieldId: 'service_toggle',
          fieldValue: {
            single: 'true',
            type: 'SINGLE',
          },
        },
        {
          fieldId: 'service_date_time',
          fieldValue: {
            single: '2025-05-18T05:00:00Z',
            type: 'SINGLE',
          },
        },
      ],
    },
    device: {
      createdBy: faker.string.uuid(),
      creationDate: faker.date.recent(),
      updateDate: faker.date.recent(),
      updatedBy: faker.string.uuid(),
      serviceId: '22222222-1b4d-4336-99b8-548e08b05777',
      id: '282ac790-529f-47c4-99b2-4265a496ef40',
      templateId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05666',
      serviceVersion: 'v2',
      values: [],
      // values: [
      //   {
      //     fieldId: 'Parameter_2',
      //     fieldValue: {
      //       single: '2',
      //       type: 'SINGLE',
      //     },
      //   },
      //   {
      //     fieldId: 'Services',
      //     fieldValue: {
      //       structure: [
      //         {
      //           cells: [
      //             {
      //               columnId: 'service_name',
      //               fieldValue: {
      //                 single: 'Service name example 1',
      //                 type: 'SINGLE',
      //               },
      //             },
      //             {
      //               columnId: 'service_type',
      //               fieldValue: {
      //                 single: 'CUSTOMER_PRESENT',
      //                 type: 'SINGLE',
      //               },
      //             },
      //           ],
      //           rowId: '1',
      //         },
      //         {
      //           cells: [
      //             {
      //               columnId: 'service_name',
      //               fieldValue: {
      //                 single: 'Service name example 2',
      //                 type: 'SINGLE',
      //               },
      //             },
      //             {
      //               columnId: 'service_type',
      //               fieldValue: {
      //                 single: 'CUSTOMER_PRESENT',
      //                 type: 'SINGLE',
      //               },
      //             },
      //           ],
      //           rowId: '2',
      //         },
      //       ],
      //       type: 'STRUCTURE',
      //     },
      //   },
      //   {
      //     fieldId: 'EcrConnectionConfig',
      //     fieldValue: {
      //       structure: [
      //         {
      //           cells: [
      //             {
      //               columnId: 'connection_name',
      //               fieldValue: {
      //                 single: 'Connection name value',
      //                 type: 'SINGLE',
      //               },
      //             },
      //             {
      //               columnId: 'RefECRLink',
      //               fieldValue: {
      //                 structure: [
      //                   {
      //                     cells: [
      //                       {
      //                         columnId: 'test_name_1',
      //                         fieldValue: {
      //                           single: 'LINK1',
      //                           type: 'SINGLE',
      //                         },
      //                       },
      //                     ],
      //                     rowId: 'RefECRLink-row-1',
      //                   },
      //                   {
      //                     cells: [
      //                       {
      //                         columnId: 'test_name_1',
      //                         fieldValue: {
      //                           single: 'LINK2',
      //                           type: 'SINGLE',
      //                         },
      //                       },
      //                       {
      //                         columnId: 'test_name_2',
      //                         fieldValue: {
      //                           single: 'Test name 2 value',
      //                           type: 'SINGLE',
      //                         },
      //                       },
      //                     ],
      //                     rowId: 'RefECRLink-row-2',
      //                   },
      //                 ],
      //                 type: 'STRUCTURE',
      //               },
      //             },
      //           ],
      //           rowId: 'RowEcrConnectionConfig1',
      //         },
      //       ],
      //       type: 'STRUCTURE',
      //     },
      //   },
      //   {
      //     fieldId: 'service_choices',
      //     fieldValue: {
      //       single: '["CHOICE_3"]',
      //       type: 'SINGLE',
      //     },
      //   },
      //   {
      //     fieldId: 'service_toggle',
      //     fieldValue: {
      //       single: 'true',
      //       type: 'SINGLE',
      //     },
      //   },
      //   {
      //     fieldId: 'service_date_time',
      //     fieldValue: {
      //       single: '2025-05-18T05:00:00Z',
      //       type: 'SINGLE',
      //     },
      //   },
      // ],
    },
  });
}

// eslint-disable-next-line max-lines-per-function
export function getTemplateByIdV1CustomHandler(context: ResponseResolverInfo<HttpRequestResolverExtras<PathParams>>) {
  const { templateId } = context.params;
  return HttpResponse.json<TemplateResourceReadApi>({
    scope: 'SERVER',
    status: 'ACTIVE',
    version: '1.0.0',
    id: templateId as string,
    parameter: {
      containers: [
        {
          description: 'Description 1',
          id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
          name: 'Tab1',
        },
        {
          description: 'Description 2',
          id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05803',
          name: 'Tab2',
        },
        {
          description: 'Description 2',
          id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05804',
          name: 'Tab3',
        },
      ],
      fields: [
        {
          dataType: 'ENUM',
          definition: {
            dynamicChoice: {
              fieldId: 'Services',
              fieldLabelId: 'service_name',
              fieldValueId: 'service_name',
            },
          },
          description: 'dynamic field description',
          elementType: 'DYNAMIC_CHOICE',
          id: 'dynamic_choices_tab1',
          isRequired: false,
          name: 'Dynamic Choice',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
        },
        {
          dataType: 'ENUM',
          definition: {
            common: {
              uiComponentOptions: {
                multiSelect: {
                  defaultSelectedIds: [],
                  hint: 'HINT multi select service choice',
                  isRequired: false,
                  label: 'service choice label',
                  choices: [
                    {
                      id: 1,
                      label: 'Choice 1',
                      order: 1,
                      value: 'CHOICE_1',
                    },
                    {
                      id: 2,
                      label: 'Choice 2',
                      order: 2,
                      value: 'CHOICE_2',
                    },
                    {
                      id: 3,
                      label: 'Choice 3',
                      order: 3,
                      value: 'CHOICE_3',
                    },
                  ],
                  placeholder: 'service choice placeholder',
                },
              },
              uiComponentType: 'MULTI_SELECT',
            },
          },
          description: 'Multi select description',
          elementType: 'COMMON',
          id: 'service_choices_tab1',
          isRequired: false,
          name: 'Service Choices Tab1',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
        },
        {
          dataType: 'ENUM',
          definition: {
            common: {
              uiComponentOptions: {
                select: {
                  hint: 'HINT select service type',
                  isRequired: false,
                  label: 'service type label',
                  choices: [
                    {
                      id: 1,
                      label: 'CUSTOMER_PRESENT',
                      order: 1,
                      value: 'CUSTOMER_PRESENT',
                    },
                    {
                      id: 2,
                      label: 'CUSTOMER_NOT_PRESENT',
                      order: 2,
                      value: 'CUSTOMER__NOTPRESENT',
                    },
                  ],
                  placeholder: 'service type placeholder',
                },
              },
              uiComponentType: 'SELECT',
            },
          },
          description: 'mockedDescription',
          elementType: 'COMMON',
          id: 'service_type_tab1',
          isRequired: false,
          name: 'Service Type',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
        },
        {
          dataType: 'STRING',
          definition: {
            common: {
              uiComponentOptions: {
                inputString: {
                  hint: 'Description hint',
                  isRequired: false,
                  label: 'Parameter1 label',
                  defaultValue: '',
                  maxLength: 200,
                  minLength: 1,
                  pattern: {
                    errorMessage: 'Error message',
                    value: '^[^é]*$',
                  },
                  placeholder: 'Parameter 1 placeholder',
                  type: 'TEXT',
                },
              },
              uiComponentType: 'INPUT',
            },
          },
          description: 'Description for parameter 1',
          elementType: 'COMMON',
          id: 'Parameter_1',
          isRequired: false,
          name: 'Parameter 1',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
        },
        {
          dataType: 'NUMBER',
          definition: {
            common: {
              uiComponentOptions: {
                inputNumber: {
                  hint: 'Description hint 2',
                  isRequired: true,
                  label: 'Parameter2 label',
                  defaultValue: 3,
                  max: 5,
                  min: 1,
                  placeholder: 'Parameter 2 placeholder',
                },
              },
              uiComponentType: 'INPUT',
            },
          },
          description: 'Description for parameter 2',
          elementType: 'COMMON',
          id: 'Parameter_2',
          isRequired: true,
          name: 'Parameter 2',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
        },
        {
          dataType: 'STRUCTURE',
          definition: {
            structure: {
              childFields: [
                {
                  dataType: 'STRING',
                  definition: {
                    common: {
                      uiComponentOptions: {
                        inputString: {
                          hint: 'Description hint',
                          isRequired: true,
                          label: 'service name label',
                          defaultValue: '',
                          maxLength: 200,
                          minLength: 1,
                          pattern: {
                            errorMessage: 'Error message',
                            value: '^[^é]*$',
                          },
                          placeholder: 'service name placeholder',
                          type: 'TEXT',
                        },
                      },
                      uiComponentType: 'INPUT',
                    },
                  },
                  description: 'mockedDescription',
                  elementType: 'COMMON',
                  id: 'service_name',
                  isRequired: false,
                  name: 'Service Name',
                },
                {
                  dataType: 'ENUM',
                  definition: {
                    common: {
                      uiComponentOptions: {
                        select: {
                          hint: 'HINT select service type',
                          isRequired: false,
                          label: 'service type label',
                          choices: [
                            {
                              id: 1,
                              label: 'CUSTOMER_PRESENT',
                              order: 1,
                              value: 'CUSTOMER_PRESENT',
                            },
                            {
                              id: 2,
                              label: 'CUSTOMER_NOT_PRESENT',
                              order: 2,
                              value: 'CUSTOMER__NOTPRESENT',
                            },
                          ],
                          placeholder: 'service type placeholder',
                        },
                      },
                      uiComponentType: 'SELECT',
                    },
                  },
                  description: 'mockedDescription',
                  elementType: 'COMMON',
                  id: 'service_type',
                  isRequired: false,
                  name: 'Service Type',
                },
              ],
            },
          },
          description: 'Description for parameter structure Services',
          elementType: 'STRUCTURE',
          id: 'Services',
          isRequired: true,
          name: 'Services',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05803',
        },
        {
          dataType: 'STRUCTURE',
          definition: {
            structure: {
              childFields: [
                {
                  dataType: 'STRING',
                  definition: {
                    common: {
                      uiComponentOptions: {
                        inputString: {
                          hint: 'Description hint connection name',
                          isRequired: true,
                          label: 'connection name label',
                          defaultValue: '',
                          pattern: {
                            errorMessage: 'Error message',
                            value: '^[^é]*$',
                          },
                          placeholder: 'connection name placeholder',
                          type: 'TEXT',
                        },
                      },
                      uiComponentType: 'INPUT',
                    },
                  },
                  description: 'mockedDescription',
                  elementType: 'COMMON',
                  id: 'connection_name',
                  isRequired: true,
                  name: 'Connection Name',
                },
                {
                  dataType: 'STRUCTURE',
                  definition: {
                    structure: {
                      childFields: [
                        {
                          dataType: 'STRING',
                          definition: {
                            common: {
                              uiComponentOptions: {
                                inputString: {
                                  hint: 'Description hint test_name_1',
                                  isRequired: true,
                                  label: 'test_name_1 label',
                                  defaultValue: '',
                                  placeholder: 'test_name_1 placeholder',
                                  type: 'TEXT',
                                },
                              },
                              uiComponentType: 'INPUT',
                            },
                          },
                          description: 'mockedDescription',
                          elementType: 'COMMON',
                          id: 'test_name_1',
                          isRequired: false,
                          name: 'Test Name 1',
                        },
                        {
                          dataType: 'STRING',
                          definition: {
                            common: {
                              uiComponentOptions: {
                                inputString: {
                                  hint: 'Description hint test_name_2',
                                  isRequired: true,
                                  label: 'test name 2 label',
                                  defaultValue: '',
                                  maxLength: 200,
                                  minLength: 1,
                                  pattern: {
                                    errorMessage: 'Error message',
                                    value: '^[^é]*$',
                                  },
                                  placeholder: 'test_name_2 placeholder',
                                  type: 'TEXT',
                                },
                              },
                              uiComponentType: 'INPUT',
                            },
                          },
                          description: 'mockedDescription',
                          elementType: 'COMMON',
                          id: 'test_name_2',
                          isRequired: true,
                          name: 'Test Name 2',
                        },
                      ],
                    },
                  },
                  description: 'Description for parameter structure RefECRLink',
                  elementType: 'STRUCTURE',
                  id: 'RefECRLink',
                  isRequired: true,
                  name: 'Ref ECR Link',
                },
              ],
            },
          },
          description: 'Description for parameter structure EcrConnectionConfig',
          elementType: 'STRUCTURE',
          id: 'EcrConnectionConfig',
          isRequired: true,
          name: 'Ecr Connection Config',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05804',
        },
        {
          dataType: 'ENUM',
          definition: {
            common: {
              uiComponentOptions: {
                multiSelect: {
                  defaultSelectedIds: [],
                  hint: 'HINT multi select service choice',
                  isRequired: false,
                  label: 'service choice label',
                  choices: [
                    {
                      id: 1,
                      label: 'Choice 1',
                      order: 1,
                      value: 'CHOICE_1',
                    },
                    {
                      id: 2,
                      label: 'Choice 2',
                      order: 2,
                      value: 'CHOICE_2',
                    },
                    {
                      id: 3,
                      label: 'Choice 3',
                      order: 3,
                      value: 'CHOICE_3',
                    },
                  ],
                  placeholder: 'service choice placeholder',
                },
              },
              uiComponentType: 'MULTI_SELECT',
            },
          },
          description: 'Multi select description',
          elementType: 'COMMON',
          id: 'service_choices',
          isRequired: false,
          name: 'Service Choices',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
        },
        {
          dataType: 'ENUM',
          definition: {
            common: {
              uiComponentOptions: {
                select: {
                  hint: 'HINT select test choice',
                  isRequired: false,
                  label: 'test choice label',
                  choices: [
                    {
                      id: 1,
                      label: 'Choice 1',
                      order: 1,
                      value: 'CHOICE_1',
                    },
                    {
                      id: 2,
                      label: 'Choice 2',
                      order: 2,
                      value: 'CHOICE_2',
                    },
                    {
                      id: 3,
                      label: 'Choice 3',
                      order: 3,
                      value: 'CHOICE_3',
                    },
                  ],
                  placeholder: 'Test choice placeholder',
                },
              },
              uiComponentType: 'SELECT',
            },
          },
          description: 'Select description',
          elementType: 'COMMON',
          id: 'test_choices',
          isRequired: false,
          name: 'Test Choices',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
        },
        {
          dataType: 'BOOLEAN',
          definition: {
            common: {
              uiComponentOptions: {
                toggle: {
                  defaultValue: true,
                  hint: 'Toggle hint',
                  label: 'Toggle label',
                },
              },
              uiComponentType: 'TOGGLE',
            },
          },
          description: 'Toggle description',
          elementType: 'COMMON',
          id: 'service_toggle',
          isRequired: true,
          name: 'Service Toggle',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05803',
        },
        {
          dataType: 'STRING',
          definition: {
            common: {
              uiComponentOptions: {
                dateTime: {
                  hint: 'Date time hint',
                  isRequired: true,
                  label: 'Date time label',
                  endDate: new Date('2025-05-16T00:00:00Z'),
                  format: 'YYYY-MM-DD HH:mm:ss',
                  startDate: new Date('2025-05-20T03:00:00Z'),
                  type: 'DATE_TIME',
                },
              },
              uiComponentType: 'DATE_TIME',
            },
          },
          description: 'Date time description',
          elementType: 'COMMON',
          id: 'service_date_time',
          isRequired: true,
          name: 'Service Date Time',
          containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05804',
        },
      ],
    },
  });
}

export function generateSmartFieldUiComponentDateTimeOptionsApi(
  override?: Partial<SmartFieldUiComponentDateTimeOptionsApi>,
): SmartFieldUiComponentDateTimeOptionsApi {
  const endDate = faker.date.recent();
  const startDate = faker.date.past({ refDate: endDate });
  return {
    defaultValue: faker.date.between({ from: startDate, to: endDate }).toISOString().replace('T', ' ').slice(0, 19),
    endDate,
    format: 'YYYY-MM-DD HH:mm:ss',
    startDate,
    type: generateFromEnum(enumSmartFieldUiComponentDateTimeType),
    ...override,
  };
}
export function generateSmartFieldUiComponentInputNumberOptionsApi(
  override?: Partial<SmartFieldUiComponentInputNumberOptionsApi>,
): SmartFieldUiComponentInputNumberOptionsApi {
  const minNumber = faker.number.int({ min: 1, max: 1000 });
  const maxNumber = faker.number.int({ min: minNumber + 2, max: minNumber + 1000 });
  const defaultValue = faker.number.int({ min: minNumber + 1, max: maxNumber - 1 });
  return {
    defaultValue,
    max: maxNumber,
    min: minNumber,
    placeholder: faker.lorem.sentence(),
    ...override,
  };
}
export function generateSmartFieldUiComponentInputStringOptionsApi(
  override?: Partial<SmartFieldUiComponentInputStringOptionsApi>,
): SmartFieldUiComponentInputStringOptionsApi {
  const minNumber = faker.number.int({ min: 1, max: 40 });
  const maxNumber = faker.number.int({ min: minNumber + 1, max: minNumber + 40 });
  return {
    defaultValue: faker.string.alphanumeric({ length: { min: minNumber + 1, max: maxNumber - 1 } }),
    maxLength: maxNumber,
    minLength: minNumber,
    placeholder: faker.lorem.sentence(),
    type: generateFromEnum(smartFieldUiComponentInputStringType),
    ...override,
  };
}

export function generateSmartFieldUiComponentSelectChoiceApi(
  override?: Partial<SmartFieldUiComponentSelectChoiceApi>,
): SmartFieldUiComponentSelectChoiceApi {
  return {
    id: faker.number.int({ min: 1 }),
    label: faker.lorem.sentence(),
    order: faker.number.int({ min: 1 }),
    value: faker.lorem.word(),
    ...override,
  };
}
export function generateSmartFieldUiComponentMultiSelectOptionsApi(
  override?: Partial<SmartFieldUiComponentMultiSelectOptionsApi>,
): SmartFieldUiComponentMultiSelectOptionsApi {
  const numberOfChoices = faker.number.int({ min: 1, max: 6 });
  return {
    choices: faker.helpers.multiple(
      (___, index) =>
        generateSmartFieldUiComponentSelectChoiceApi({
          id: index + 1,
          order: index + 1,
        }),
      { count: numberOfChoices },
    ),
    defaultSelectedIds: faker.helpers.multiple((__, index) => index + 1, { count: numberOfChoices / 2 }),
    max: faker.number.int({ min: 1 }),
    min: faker.number.int({ min: 1 }),
    placeholder: faker.lorem.sentence(),
    ...override,
  };
}
export function generateSmartFieldUiComponentSelectOptionsApi(
  override?: Partial<SmartFieldUiComponentSelectOptionsApi>,
): SmartFieldUiComponentSelectOptionsApi {
  return {
    choices: faker.helpers.multiple(
      (___, index) =>
        generateSmartFieldUiComponentSelectChoiceApi({
          id: index + 1,
          order: index + 1,
        }),
      { count: 3 },
    ),
    defaultSelectedId: 1,
    placeholder: faker.lorem.sentence(),
    ...override,
  };
}
export function generateSmartFieldUiComponentToggleOptionsApi(
  override?: Partial<SmartFieldUiComponentToggleOptionsApi>,
): SmartFieldUiComponentToggleOptionsApi {
  return {
    defaultValue: faker.datatype.boolean(),
    hint: faker.lorem.sentence(),
    label: faker.lorem.words(2),
    ...override,
  };
}

export function generateSmartFieldUiComponentOptionsNoTableApi(
  override?: Partial<SchemasSmartFieldUiComponentOptionsNoTableApi>,
): SchemasSmartFieldUiComponentOptionsNoTableApi {
  return {
    dateTime: generateSmartFieldUiComponentDateTimeOptionsApi(),
    inputNumber: generateSmartFieldUiComponentInputNumberOptionsApi(),
    inputString: generateSmartFieldUiComponentInputStringOptionsApi(),
    multiSelect: generateSmartFieldUiComponentMultiSelectOptionsApi(),
    select: generateSmartFieldUiComponentSelectOptionsApi(),
    toggle: generateSmartFieldUiComponentToggleOptionsApi(),
    ...override,
  };
}
export function generateTemplateResourceParameterFieldDefinitionCommonV2Api(
  override?: Partial<TemplateResourceParameterFieldDefinitionCommonV2Api>,
): TemplateResourceParameterFieldDefinitionCommonV2Api {
  // eslint-disable-next-line immutable/no-let
  let uiComponentType: EnumSmartFieldUiComponentNoTableTypeApi =
    generateFromEnum<EnumSmartFieldUiComponentNoTableTypeApi>(enumSmartFieldUiComponentNoTableType);
  if (uiComponentType === enumSmartFieldUiComponentNoTableType.DATE_TIME) {
    uiComponentType = enumSmartFieldUiComponentNoTableType.INPUT;
  }

  return {
    uiComponentOptions: generateSmartFieldUiComponentOptionsNoTableApi(),
    ...override,
    uiComponentType: enumSmartFieldUiComponentNoTableType.INPUT,
  };
}
export function generateTemplateResourceParameterFieldDefinitionDynamicChoiceV2Api(
  override?: Partial<TemplateResourceParameterFieldDefinitionDynamicChoiceV2Api>,
): TemplateResourceParameterFieldDefinitionDynamicChoiceV2Api {
  return {
    fieldId: faker.string.uuid(),
    fieldLabelId: faker.string.uuid(),
    fieldValueId: faker.string.uuid(),
    ...override,
  };
}
export function generateTemplateResourceParameterFieldDefinitionStructureV2Api(
  override?: Partial<TemplateResourceParameterFieldDefinitionStructureV2Api>,
): TemplateResourceParameterFieldDefinitionStructureV2Api {
  return {
    childFields: faker.helpers.multiple(() => generateTemplateResourceParameterFieldV2Api(), { count: 3 }),
    maxRows: faker.number.int({ min: 1 }),
    minRows: faker.number.int({ min: 1 }),
    ...override,
  };
}

export function generateTemplateResourceParameterFieldDefinitionV2Api(
  override?: Partial<TemplateResourceParameterFieldDefinitionV2Api>,
): TemplateResourceParameterFieldDefinitionV2Api {
  return {
    common: generateTemplateResourceParameterFieldDefinitionCommonV2Api(),
    dynamicChoice: generateTemplateResourceParameterFieldDefinitionDynamicChoiceV2Api(),
    ...override,
    // structure: generateTemplateResourceParameterFieldDefinitionStructureV2Api(),
    structure: undefined,
  };
}

export function generateTemplateResourceParameterFieldV2Api(
  override?: Partial<TemplateResourceParameterFieldV2Api>,
): TemplateResourceParameterFieldV2Api {
  // eslint-disable-next-line immutable/no-let
  let dataType: EnumSmartFieldDataTypeApi = generateFromEnum(enumSmartFieldDataType);
  if (dataType === enumSmartFieldDataType.STRUCTURE || dataType === enumSmartFieldDataType.DATE) {
    dataType = enumSmartFieldDataType.STRING as EnumSmartFieldDataTypeApi;
  }
  return {
    dataType: enumSmartFieldDataType.STRING,
    definition: generateTemplateResourceParameterFieldDefinitionV2Api(),
    description: faker.commerce.productDescription(),
    elementType: 'COMMON',
    id: faker.string.uuid(),
    isRequired: faker.datatype.boolean(),
    isTerminalModifiable: faker.datatype.boolean(),
    name: faker.commerce.productName(),
    ...override,
  };
}
export function generateTemplateResourceParameterFieldRootV2Api(
  override?: Partial<TemplateResourceParameterFieldRootV2Api>,
): TemplateResourceParameterFieldRootV2Api {
  return {
    ...generateTemplateResourceParameterFieldV2Api(),
    containerId: faker.string.uuid(),
    ...override,
  };
}
export function generateTemplateResourceParameterContainerV2Api(
  override?: Partial<TemplateResourceParameterContainerV2Api>,
): TemplateResourceParameterContainerV2Api {
  return {
    description: faker.commerce.productDescription(),
    id: faker.string.uuid(),
    name: faker.company.name(),
    ...override,
  };
}
export function generateTemplateDetailedResourceParameterV2Api(
  override?: Partial<TemplateDetailedResourceParameterV2Api>,
): TemplateDetailedResourceParameterV2Api {
  return {
    containers: faker.helpers.multiple(() => generateTemplateResourceParameterContainerV2Api(), {
      count: NUMBER_FORM_GENERATOR_CONTAINERS_FIELDS,
    }),
    fields: faker.helpers.multiple(() => generateTemplateResourceParameterFieldRootV2Api(), {
      count: NUMBER_FORM_GENERATOR_CONTAINERS_FIELDS * NUMBER_FORM_GENERATOR_FIELDS,
    }),
    ...override,
  };
}
export function generateCustomTemplateDetailedResourceParameterV2Api(
  override?: Partial<TemplateDetailedResourceParameterV2Api>,
): TemplateDetailedResourceParameterV2Api {
  return {
    containers: faker.helpers.multiple(
      (__, index) =>
        generateTemplateResourceParameterContainerV2Api({
          id: getFormGeneratorContainersIdByIndex(index),
        }),
      {
        count: NUMBER_FORM_GENERATOR_CONTAINERS_FIELDS,
      },
    ),
    fields: faker.helpers.multiple(
      (__, index) =>
        generateTemplateResourceParameterFieldRootV2Api({
          containerId: getFormGeneratorContainersIdByIndex(index % NUMBER_FORM_GENERATOR_CONTAINERS_FIELDS),
          id: getFormGeneratorIdByIndex(index),
          // dataType: enumSmartFieldDataType.STRING, // EDIT [PEDRO] Update here to handle distinct inputs
        }),
      {
        count: NUMBER_FORM_GENERATOR_CONTAINERS_FIELDS * NUMBER_FORM_GENERATOR_FIELDS,
      },
    ),
    ...override,
  };
}

export function generateTemplateDetailedResourceReadV2Api(
  override?: Partial<TemplateDetailedResourceReadV2Api>,
): TemplateDetailedResourceReadV2Api {
  return {
    checksum: '9c56cc51d345e3c4f06cf26a4d25a15b71b75f6c6f2f80f1ed1b5a4fc282a6f5',
    componentType: 'APPLICATION',
    createdBy: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
    creationDate: new Date('2021-01-01T00:00:00Z'),
    description: 'Template for managing device configurations.',
    extension: 'xml',
    fileName: 'template.xml',
    id: faker.string.uuid(),
    mimeType: 'application/zip',
    name: 'Device Configuration Template',
    size: 102_400,
    targetLocation: 'SystemSettings/Configurations',
    templateFileId: 'simpleId',
    templateFileName: 'Device Configuration Template',
    templateFileVersion: 'v2.1',
    type: 'TEMPLATE',
    parameter: generateTemplateDetailedResourceParameterV2Api(),
    ...override,
  };
}

export function getFormGeneratorTemplateByIdCustomHandler(
  context: ResponseResolverInfo<HttpRequestResolverExtras<PathParams>>,
) {
  return HttpResponse.json<TemplateDetailedResourceReadV2Api>(
    generateTemplateDetailedResourceReadV2Api({
      parameter: generateCustomTemplateDetailedResourceParameterV2Api(),
      id: getTemplateIdByIndex(0),
    }),
  );
}

// MOCK UP FROM REAL API CALLS
//template by id v2:

const templateByIdPayload: TemplateDetailedResourceReadV2Api = {
  checksum: 'yEu8SPKBYmQTPqD9sT3/U3cCTYUfhbb0/a1JBU6GVZPoveCTgmcmHYQF2dDEZ9zuU3AbZndhtCl5/AlFA031kA==',
  componentType: 'APPLICATION',
  createdBy: 'eb7c1ba7-99d5-479c-808e-47383ee1180e',
  creationDate: new Date('2025-06-11T17:08:09.46177Z'),
  extension: 'xml',
  fileName: 'common_config_10462.xml',
  id: '5feb665e-039b-4cd4-bf8e-290a75a623ee',
  mimeType: 'text/xml',
  size: 48_111,
  type: 'TEMPLATE',
  description: 'Common Parameters',
  name: 'common_config',
  targetApplication: 'targetApplication',
  targetLocation: 'UNKNOWN',
  templateFileId: 'common_config',
  templateFileName: 'common_config',
  templateFileVersion: '10462',
  updateFileName: 'updateFileName',
  parameter: {
    containers: [
      {
        description: '',
        id: '992a0f05-4238-3f1e-a5ef-51b7cf4ae6c4',
        name: 'Services',
      },
      {
        description: '',
        id: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
        name: 'Terminal',
      },
      {
        description: '',
        id: 'e362169c-73dc-3146-905d-1937c6f893d9',
        name: 'CA Public Keys',
      },
      {
        description: '',
        id: '13d80777-c8fd-33e5-95c1-f5b1b72d7ef0',
        name: 'Host configuration',
      },
      {
        description: '',
        id: '0f58a29d-ca60-31a5-ae32-1aa2d5c3e507',
        name: 'Comms Network Connection Type',
      },
      {
        description: '',
        id: '8c7f5a2e-454f-35f8-a662-e32b3a8cc4e0',
        name: 'Comms',
      },
      {
        description: '',
        id: '2fae3262-9d4e-34fc-a341-f1751b405e45',
        name: 'Security',
      },
    ],
    fields: [
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Service Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Service Name (e.g. Customer Present)',
                elementType: 'COMMON',
                id: 'service_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Service Name',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Service Type',
                        choices: [
                          {
                            id: 1,
                            label: 'CUSTOMER_PRESENT',
                            order: 1,
                            value: 'CUSTOMER_PRESENT',
                          },
                          {
                            id: 2,
                            label: 'CUSTOMER_NOT_PRESENT',
                            order: 2,
                            value: 'CUSTOMER_NOT_PRESENT',
                          },
                        ],
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'Service Type (e.g. CUSTOMER_PRESENT)',
                elementType: 'COMMON',
                id: 'service_type',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Service Type',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'service_name',
          },
        },
        elementType: 'STRUCTURE',
        id: 'Service',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Services',
        containerId: '992a0f05-4238-3f1e-a5ef-51b7cf4ae6c4',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Application Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The name of the application',
                elementType: 'COMMON',
                id: 'app_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Application Name',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Application Package',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The package of the application',
                elementType: 'COMMON',
                id: 'app_package',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Application Package',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'app_name',
          },
        },
        elementType: 'STRUCTURE',
        id: 'Application',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Applications',
        containerId: '992a0f05-4238-3f1e-a5ef-51b7cf4ae6c4',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Network Timeout Period (minutes)',
                defaultValue: '10',
                maxLength: 3,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description:
          'The time period (in minutes) during which if a transaction is initiated, the terminal can use the previous successful connection type',
        elementType: 'COMMON',
        id: 'network_timeout_period',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Network Timeout Period (minutes)',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Config Finger Print',
                defaultValue: '',
                maxLength: 255,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description:
          'This field is currently used as part of the input to the functionality create/generate and save TerminalReport.',
        elementType: 'COMMON',
        id: 'config_fingerprint',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Config Finger Print',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Contactess Retry Counter',
                defaultValue: '3',
                maxLength: 2,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Defines the number of retry attempts the user can tap the card',
        elementType: 'COMMON',
        id: 'cless_retry_counter',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Contactess Retry Counter',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'IC Contact Retry Counter',
                defaultValue: '3',
                maxLength: 2,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Defines the number of retry attempts the user can reinsert the card',
        elementType: 'COMMON',
        id: 'icc_retry_counter',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'IC Contact Retry Counter',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Magstripe Retry Counter',
                defaultValue: '3',
                maxLength: 2,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Defines the number of retry attempts the user can swipe the card',
        elementType: 'COMMON',
        id: 'magstripe_retry_counter',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Magstripe Retry Counter',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Allow Contactless Fall Forward',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 2,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'Allow fall forward to contactless then swipe when insert failed',
        elementType: 'COMMON',
        id: 'allow_contactless_fall_forward',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Allow Contactless Fall Forward',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Country Code',
                defaultValue: '',
                maxLength: 3,
                minLength: 3,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Defines the country code of the terminal',
        elementType: 'COMMON',
        id: 'country_code',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Country Code',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Pin Retry Counter',
                defaultValue: '3',
                maxLength: 2,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Defines the retry attempts to enter PIN',
        elementType: 'COMMON',
        id: 'pin_retry_counter',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Pin Retry Counter',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Alternative payment enable',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description:
          'Indicates whether terminal supports alternative payment methods. This parameter is set at both terminal level and transaction type level.',
        elementType: 'COMMON',
        id: 'alternative_payment_method_enable',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Alternative payment enable',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Country Flag Icon',
                defaultValue: '',
                maxLength: 65_535,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description:
          'Defines the icon of the country flag. This parameter is set at both terminal level and bin range level.',
        elementType: 'COMMON',
        id: 'country_flag_icon',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Country Flag Icon',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Enable manual entry',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'When true, terminal displays the manual entry mode at card capture screen',
        elementType: 'COMMON',
        id: 'enable_manual_entry',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Enable manual entry',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: true,
                label: 'Enable QR',
                choices: [
                  {
                    id: 1,
                    label: 'DISABLED',
                    order: 1,
                    value: 'DISABLED',
                  },
                  {
                    id: 2,
                    label: 'FRONT_CAMERA',
                    order: 2,
                    value: 'FRONT_CAMERA',
                  },
                  {
                    id: 3,
                    label: 'BACK_CAMERA',
                    order: 3,
                    value: 'BACK_CAMERA',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'Disable QR Scan or select the camera for the scan',
        elementType: 'COMMON',
        id: 'enable_qr_scan',
        isRequired: true,
        isTerminalModifiable: false,
        name: 'Enable QR',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Screen Signature Enabled',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'When enabled, allows the cardholder to sign directly on the terminal screen',
        elementType: 'COMMON',
        id: 'screen_signature_enabled',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Screen Signature Enabled',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Signature timeout (seconds)',
                defaultValue: '30',
                maxLength: 5,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Timeout in seconds for signature screen',
        elementType: 'COMMON',
        id: 'signature_timeout',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Signature timeout (seconds)',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Present card timeout (seconds)',
                defaultValue: '30',
                maxLength: 5,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Timeout in second for present card screen',
        elementType: 'COMMON',
        id: 'search_card_timeout',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Present card timeout (seconds)',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: true,
                label: 'Signature Timeout Action',
                choices: [
                  {
                    id: 1,
                    label: 'Approve',
                    order: 1,
                    value: 'Approve',
                  },
                  {
                    id: 2,
                    label: 'Decline',
                    order: 2,
                    value: 'Decline',
                  },
                  {
                    id: 3,
                    label: 'None',
                    order: 3,
                    value: 'None',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'When Approve on timeout, signature will be approved. When Decline, signature will be declined.',
        elementType: 'COMMON',
        id: 'signature_timeout_action',
        isRequired: true,
        isTerminalModifiable: false,
        name: 'Signature Timeout Action',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Captive URL HTTP',
                defaultValue: '',
                maxLength: 65_535,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'HTTP URL for Captive Portal setting',
        elementType: 'COMMON',
        id: 'captive_url_http',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Captive URL HTTP',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Captive URL HTTPS',
                defaultValue: '',
                maxLength: 65_535,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'HTTPS URL for Captive Portal setting',
        elementType: 'COMMON',
        id: 'captive_url_https',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Captive URL HTTPS',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Pre Auth code validation enabled by terminal',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 2,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description:
          'When this parameter is enabled, the terminal will search its database if the entered pre-auth code exists. This parameter is ignored if the preauth_code_validated_by_host parameter is enabled.',
        elementType: 'COMMON',
        id: 'preauth_code_validated_by_terminal',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Pre Auth code validation enabled by terminal',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Pre Auth code validation enabled by host',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 2,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description:
          'When this parameter is enabled, the terminal will need to contact the host to validate the entered pre-auth code.',
        elementType: 'COMMON',
        id: 'preauth_code_validated_by_host',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Pre Auth code validation enabled by host',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Touch Sounds',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 2,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'Enable touch sounds for payment app',
        elementType: 'COMMON',
        id: 'touch_sounds',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Touch Sounds',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: true,
                label: 'Enable Navigation Bar',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'Enabled',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'Disabled',
                  },
                  {
                    id: 3,
                    label: 'Ignored',
                    order: 3,
                    value: 'Ignored',
                  },
                ],
                defaultSelectedId: 3,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description:
          'When enabled, the Android navigation bar will be active. When disabled, the navigation bar will be hidden while payment app is running and restored after exit. When Ignored, the current status of navigation bar will be kept, any third-party app`s setting will not be affected.',
        elementType: 'COMMON',
        id: 'navi_bar_status',
        isRequired: true,
        isTerminalModifiable: false,
        name: 'Enable Navigation Bar',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: true,
                label: 'Power button',
                choices: [
                  {
                    id: 1,
                    label: 'None',
                    order: 1,
                    value: 'None',
                  },
                  {
                    id: 2,
                    label: 'Short press disabled',
                    order: 2,
                    value: 'Short press disabled',
                  },
                  {
                    id: 3,
                    label: 'Short long press disabled',
                    order: 3,
                    value: 'Short long press disabled',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description:
          'When None, keep default behavior of power button. When Short press disabled, disable short press only, so no action when we press power button shortly. When Short long press disabled, disable both short press and long press, so power button will not take action when we press shortly or long press for 2-3 seconds.',
        elementType: 'COMMON',
        id: 'power_button',
        isRequired: true,
        isTerminalModifiable: false,
        name: 'Power button',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Idle file name',
                defaultValue: '',
                maxLength: 255,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description:
          'File name of the image (screensaver) to display when terminal is idle for a given period of time set in idle_screen_timeout parameter.',
        elementType: 'COMMON',
        id: 'idle_file_name',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Idle file name',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Idle screen timeout (seconds)',
                defaultValue: '60',
                maxLength: 5,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'The time period (in seconds) that the payment app is idle before the screensaver is displayed.',
        elementType: 'COMMON',
        id: 'idle_screen_timeout',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Idle screen timeout (seconds)',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Dim Enabled',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description:
          'When enabled, screen dimming will activate when the screen is idle. Screen dimming will not take into effect when a transaction is in progress. When disabled, screen will always be visible.',
        elementType: 'COMMON',
        id: 'dim_enabled',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Dim Enabled',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Visually Impaired Mode',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'when enabled, the eye icon should be displayed',
        elementType: 'COMMON',
        id: 'visually_impaired_mode',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Visually Impaired Mode',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Pin mat supported',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 2,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description:
          'When enabled, visually impaired mode will utilise pin mat accessory. When disabled, voice guidance mode will be used',
        elementType: 'COMMON',
        id: 'pin_mat_supported',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Pin mat supported',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Auto close app and open other APK',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 2,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'when enabled, payment app will automatically open app defined in package_name_to_open on idle',
        elementType: 'COMMON',
        id: 'auto_close_app_open_other',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Auto close app and open other APK',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Package name to open',
                defaultValue: '',
                maxLength: 255,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'package name of the APK to open',
        elementType: 'COMMON',
        id: 'package_name_to_open',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Package name to open',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Display transaction result screens',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'when disable, the transaction result screen will not display',
        elementType: 'COMMON',
        id: 'display_transaction_result_screen',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Display transaction result screens',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Timeout for transaction result screen (ms)',
                defaultValue: '10000',
                maxLength: 255,
                minLength: 1,
                pattern: {
                  value: '^(\\d+(\\.\\d+)?)$',
                },
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Timeout for transaction result screens in milliseconds',
        elementType: 'COMMON',
        id: 'transaction_result_screen_timeout',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Timeout for transaction result screen (ms)',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Operation Type',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Available operations',
                elementType: 'COMMON',
                id: 'operation_type',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Operation Type',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Operation Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The name of operation',
                elementType: 'COMMON',
                id: 'operation_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Operation Name',
              },
            ],
            maxRows: 9999,
          },
        },
        elementType: 'STRUCTURE',
        id: 'TerminalOperation',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Terminal Operations',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'User Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The name of supervisors and managers of the Terminal.',
                elementType: 'COMMON',
                id: 'user_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'User Name',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'User Password',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The password of supervisors and managers of the Terminal.',
                elementType: 'COMMON',
                id: 'user_password',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'User Password',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Permission Level',
                        choices: [
                          {
                            id: 1,
                            label: 'MANGER',
                            order: 1,
                            value: 'MANGER',
                          },
                          {
                            id: 2,
                            label: 'SUPERVISOR',
                            order: 2,
                            value: 'SUPERVISOR',
                          },
                        ],
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'The Permission Level of supervisors and managers of the Terminal.',
                elementType: 'COMMON',
                id: 'permission_level',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Permission Level',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'user_name',
          },
        },
        elementType: 'STRUCTURE',
        id: 'TerminalUserManagement',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Terminal Users Management',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Battery Level Indicator',
                        choices: [
                          {
                            id: 1,
                            label: 'CRITICAL',
                            order: 1,
                            value: 'CRITICAL',
                          },
                          {
                            id: 2,
                            label: 'WARNING',
                            order: 2,
                            value: 'WARNING',
                          },
                          {
                            id: 3,
                            label: 'OK',
                            order: 3,
                            value: 'OK',
                          },
                        ],
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'Name of battery level',
                elementType: 'COMMON',
                id: 'battery_level_indicator',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Battery Level Indicator',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Battery Percentage',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        pattern: {
                          value: '^(\\d+(\\.\\d+)?)$',
                        },
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Upper limit of battery percentage indicator',
                elementType: 'COMMON',
                id: 'battery_level_percentage',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Battery Percentage',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'battery_level_indicator',
          },
        },
        elementType: 'STRUCTURE',
        id: 'BatteryStatusManagement',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Battery Status Management',
        containerId: '514d8a49-4f08-3c0d-949b-9536c2ef3bd9',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'RID',
                        defaultValue: '',
                        maxLength: 10,
                        minLength: 10,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Registered Application Provider Identifier.',
                elementType: 'COMMON',
                id: 'rid',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'RID',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'RID Index',
                        defaultValue: '',
                        maxLength: 4,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The RID Index',
                elementType: 'COMMON',
                id: 'rid_index',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'RID Index',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Exponent',
                        defaultValue: '',
                        maxLength: 8,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'RSA public key Exponent',
                elementType: 'COMMON',
                id: 'exponent',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Exponent',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Modulus',
                        defaultValue: '',
                        maxLength: 2048,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'RSA public key modulus ',
                elementType: 'COMMON',
                id: 'modulus',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Modulus',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'SHA1',
                        defaultValue: '',
                        maxLength: 1024,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The SHA1 of capk',
                elementType: 'COMMON',
                id: 'sha1',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'SHA1',
              },
            ],
            maxRows: 9999,
          },
        },
        elementType: 'STRUCTURE',
        id: 'Capk',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'CA Public Key',
        containerId: 'e362169c-73dc-3146-905d-1937c6f893d9',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Host Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Name of the host.',
                elementType: 'COMMON',
                id: 'host_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Host Name',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Currency Provider conversion',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description:
                  'Name of the currency conversion provider which will be printed on customer receipt to indicate DCC process solution provider.',
                elementType: 'COMMON',
                id: 'currency_conversion_provider',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Currency Provider conversion',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Best Rate Currency Guarantee Disclaimer',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description:
                  'Best rate currency guarantee disclaimer which will be printed on transaction receipts if DCC transaction is performed.',
                elementType: 'COMMON',
                id: 'best_rate_curr_guarantee_disclaimer',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Best Rate Currency Guarantee Disclaimer',
              },
              {
                dataType: 'STRUCTURE',
                definition: {
                  structure: {
                    childFields: [
                      {
                        dataType: 'STRING',
                        definition: {
                          dynamicChoice: {
                            fieldId: 'CommsConfig',
                            fieldLabelId: 'comms_name',
                            fieldValueId: 'comms_name',
                          },
                        },
                        description:
                          'Name of the communication host. Select, from the drop-down list, the name that matches the one set up in CommsConfigs',
                        elementType: 'DYNAMIC_CHOICE',
                        id: 'comms',
                        isRequired: false,
                        isTerminalModifiable: false,
                        name: 'Comms Config',
                      },
                    ],
                    maxRows: 20,
                  },
                },
                elementType: 'STRUCTURE',
                id: 'RefCommsConfig',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Comms Config',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Logon Required',
                        choices: [
                          {
                            id: 1,
                            label: 'Enabled',
                            order: 1,
                            value: 'true',
                          },
                          {
                            id: 2,
                            label: 'Disabled',
                            order: 2,
                            value: 'false',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description:
                  'When enabled, the payment application will attempt to perform logon for all acquirers which failed in the previous update and for newly added acquirers in the current update',
                elementType: 'COMMON',
                id: 'logon_required',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Logon Required',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Reconciliation Required',
                        choices: [
                          {
                            id: 1,
                            label: 'Enabled',
                            order: 1,
                            value: 'true',
                          },
                          {
                            id: 2,
                            label: 'Disabled',
                            order: 2,
                            value: 'false',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description:
                  'When enabled, the payment application will attempt to perform reconciliation for all acquirers which failed in the previous update',
                elementType: 'COMMON',
                id: 'reconciliation_required',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Reconciliation Required',
              },
              {
                dataType: 'STRING',
                definition: {
                  dynamicChoice: {
                    fieldId: 'SessionKey',
                    fieldLabelId: 'session_key_label',
                    fieldValueId: 'session_key_label',
                  },
                },
                description:
                  'Session Key label. Select, from the drop-down list, the label that matches the one set up in SessionKey',
                elementType: 'DYNAMIC_CHOICE',
                id: 'session_key',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Session Key',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Batch Upload',
                        choices: [
                          {
                            id: 1,
                            label: 'Enabled',
                            order: 1,
                            value: 'true',
                          },
                          {
                            id: 2,
                            label: 'Disabled',
                            order: 2,
                            value: 'false',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'This parameter is currently not used.',
                elementType: 'COMMON',
                id: 'batch_upload',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Batch Upload',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Use 2048 key',
                        choices: [
                          {
                            id: 1,
                            label: 'Enabled',
                            order: 1,
                            value: 'true',
                          },
                          {
                            id: 2,
                            label: 'Disabled',
                            order: 2,
                            value: 'false',
                          },
                        ],
                        defaultSelectedId: 2,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'When enabled, use 2048 key',
                elementType: 'COMMON',
                id: 'key_length_2048',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Use 2048 key',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Operator code',
                        defaultValue: '',
                        maxLength: 3,
                        minLength: 3,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The Operator code',
                elementType: 'COMMON',
                id: 'operator_code',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Operator code',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'acquirer ID',
                        defaultValue: '',
                        maxLength: 4,
                        minLength: 2,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Defines the bank host acquirer ID',
                elementType: 'COMMON',
                id: 'acquirer_id',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'acquirer ID',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Is Dcc Enabled Host',
                        choices: [
                          {
                            id: 1,
                            label: 'Enabled',
                            order: 1,
                            value: 'true',
                          },
                          {
                            id: 2,
                            label: 'Disabled',
                            order: 2,
                            value: 'false',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'enable/disable dcc support mode on host',
                elementType: 'COMMON',
                id: 'is_dcc_enabled',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Is Dcc Enabled Host',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Host Protocol',
                        choices: [
                          {
                            id: 1,
                            label: 'std70',
                            order: 1,
                            value: 'std70',
                          },
                          {
                            id: 2,
                            label: 'upi',
                            order: 2,
                            value: 'upi',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'protocol of host such as upi, std70,…',
                elementType: 'COMMON',
                id: 'protocol',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Host Protocol',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'host_name',
          },
        },
        elementType: 'STRUCTURE',
        id: 'IsoHostConfig',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Iso Hosts',
        containerId: '13d80777-c8fd-33e5-95c1-f5b1b72d7ef0',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Host Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The name of host',
                elementType: 'COMMON',
                id: 'host_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Host Name',
              },
              {
                dataType: 'STRUCTURE',
                definition: {
                  structure: {
                    childFields: [
                      {
                        dataType: 'STRING',
                        definition: {
                          dynamicChoice: {
                            fieldId: 'CommsConfig',
                            fieldLabelId: 'comms_name',
                            fieldValueId: 'comms_name',
                          },
                        },
                        description:
                          'Name of the communication host. Select, from the drop-down list, the name that matches the one set up in CommsConfigs',
                        elementType: 'DYNAMIC_CHOICE',
                        id: 'comms',
                        isRequired: false,
                        isTerminalModifiable: false,
                        name: 'Comms Config',
                      },
                    ],
                    maxRows: 20,
                  },
                },
                elementType: 'STRUCTURE',
                id: 'RefCommsConfig',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Comms Config',
              },
              {
                dataType: 'STRING',
                definition: {
                  dynamicChoice: {
                    fieldId: 'SessionKey',
                    fieldLabelId: 'session_key_label',
                    fieldValueId: 'session_key_label',
                  },
                },
                description:
                  'Session Key label. Select, from the drop-down list, the label that matches the one set up in SessionKey',
                elementType: 'DYNAMIC_CHOICE',
                id: 'session_key',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Session Key',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'acquirer ID',
                        defaultValue: '',
                        maxLength: 4,
                        minLength: 2,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'acquirer ID',
                elementType: 'COMMON',
                id: 'acquirer_id',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'acquirer ID',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'host_name',
          },
        },
        elementType: 'STRUCTURE',
        id: 'OpenAPIHostConfig',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'OpenAPI Hosts',
        containerId: '13d80777-c8fd-33e5-95c1-f5b1b72d7ef0',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Network Connection Type',
                        choices: [
                          {
                            id: 1,
                            label: 'WIFI',
                            order: 1,
                            value: 'WIFI',
                          },
                          {
                            id: 2,
                            label: 'CELL_DATA',
                            order: 2,
                            value: 'CELL_DATA',
                          },
                          {
                            id: 3,
                            label: 'ETHERNET',
                            order: 3,
                            value: 'ETHERNET',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description:
                  'Defines a list of network connection type. The order of the network connection type in the list defines its priority.',
                elementType: 'COMMON',
                id: 'network_connection_type',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Network Connection Type',
              },
            ],
            maxRows: 9999,
          },
        },
        elementType: 'STRUCTURE',
        id: 'CommsNetworkConnectionType',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Network Connection Type',
        containerId: '0f58a29d-ca60-31a5-ae32-1aa2d5c3e507',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Comms Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The Name of comms',
                elementType: 'COMMON',
                id: 'comms_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Comms Name',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'TLS Profile',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The *p12 file name which generated from CA certificate and private keys file',
                elementType: 'COMMON',
                id: 'tls_profile',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'TLS Profile',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Comms Policy',
                        choices: [
                          {
                            id: 1,
                            label: 'SEQUENTIAL',
                            order: 1,
                            value: 'SEQUENTIAL',
                          },
                          {
                            id: 2,
                            label: 'RANDOM',
                            order: 2,
                            value: 'RANDOM',
                          },
                          {
                            id: 3,
                            label: 'ROUND_ROBIN',
                            order: 3,
                            value: 'ROUND_ROBIN',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'Defines the host connection policy. Options are sequential, random, round robin.',
                elementType: 'COMMON',
                id: 'comms_policy',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Comms Policy',
              },
              {
                dataType: 'STRUCTURE',
                definition: {
                  structure: {
                    childFields: [
                      {
                        dataType: 'STRING',
                        definition: {
                          dynamicChoice: {
                            fieldId: 'Links',
                            fieldLabelId: 'link_label',
                            fieldValueId: 'link_label',
                          },
                        },
                        description: 'Defines the list of available links.',
                        elementType: 'DYNAMIC_CHOICE',
                        id: 'link_label',
                        isRequired: false,
                        isTerminalModifiable: false,
                        name: 'Link Label',
                      },
                    ],
                    maxRows: 20,
                  },
                },
                elementType: 'STRUCTURE',
                id: 'RefLinks',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Link Label',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'comms_name',
          },
        },
        elementType: 'STRUCTURE',
        id: 'CommsConfig',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Comms',
        containerId: '8c7f5a2e-454f-35f8-a662-e32b3a8cc4e0',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Label',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The link name',
                elementType: 'COMMON',
                id: 'link_label',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Label',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Network Type',
                        choices: [
                          {
                            id: 1,
                            label: 'ANY',
                            order: 1,
                            value: 'ANY',
                          },
                          {
                            id: 2,
                            label: 'WIFI',
                            order: 2,
                            value: 'WIFI',
                          },
                          {
                            id: 3,
                            label: 'CELL_DATA',
                            order: 3,
                            value: 'CELL_DATA',
                          },
                        ],
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'The network connection type',
                elementType: 'COMMON',
                id: 'network_type',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Network Type',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'TCP/IP Host Name',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The TCP/IP Host Name',
                elementType: 'COMMON',
                id: 'tcp_host_name',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'TCP/IP Host Name',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'TCP/IP Port',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        pattern: {
                          value: '^(\\d+(\\.\\d+)?)$',
                        },
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The TCP/IP Port',
                elementType: 'COMMON',
                id: 'tcp_port',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'TCP/IP Port',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'TLS Enabled',
                        choices: [
                          {
                            id: 1,
                            label: 'Enabled',
                            order: 1,
                            value: 'true',
                          },
                          {
                            id: 2,
                            label: 'Disabled',
                            order: 2,
                            value: 'false',
                          },
                        ],
                        defaultSelectedId: 2,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'enable/disable TLS connection',
                elementType: 'COMMON',
                id: 'tls_enable',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'TLS Enabled',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'TCP/IP Timeout(ms)',
                        defaultValue: '30000',
                        maxLength: 255,
                        minLength: 1,
                        pattern: {
                          value: '^(\\d+(\\.\\d+)?)$',
                        },
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The TCP/IP timeout (in milliseconds)',
                elementType: 'COMMON',
                id: 'tcp_time_out',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'TCP/IP Timeout(ms)',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'TCP/IP Framing',
                        choices: [
                          {
                            id: 1,
                            label: 'LENGTH_PREFIX_BE2',
                            order: 1,
                            value: 'LENGTH_PREFIX_BE2',
                          },
                          {
                            id: 2,
                            label: 'LENGTH_PREFIX_INCLUSIVE_BE2',
                            order: 2,
                            value: 'LENGTH_PREFIX_INCLUSIVE_BE2',
                          },
                          {
                            id: 3,
                            label: 'LENGTH_PREFIX_BE4',
                            order: 3,
                            value: 'LENGTH_PREFIX_BE4',
                          },
                          {
                            id: 4,
                            label: 'LENGTH_PREFIX_LE2',
                            order: 4,
                            value: 'LENGTH_PREFIX_LE2',
                          },
                          {
                            id: 5,
                            label: 'LENGTH_PREFIX_INCLUSIVE_LE2',
                            order: 5,
                            value: 'LENGTH_PREFIX_INCLUSIVE_LE2',
                          },
                          {
                            id: 6,
                            label: 'LENGTH_PREFIX_BCD2',
                            order: 6,
                            value: 'LENGTH_PREFIX_BCD2',
                          },
                          {
                            id: 7,
                            label: 'LENGTH_PREFIX_INCLUSIVE_BCD2',
                            order: 7,
                            value: 'LENGTH_PREFIX_INCLUSIVE_BCD2',
                          },
                        ],
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'The length indicator type prefixed to the message.',
                elementType: 'COMMON',
                id: 'tcp_framing',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'TCP/IP Framing',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Mobile network APN',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The Mobile network APN',
                elementType: 'COMMON',
                id: 'apn',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Mobile network APN',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'DSL Timeout(ms)',
                        defaultValue: '30000',
                        maxLength: 255,
                        minLength: 1,
                        pattern: {
                          value: '^(\\d+(\\.\\d+)?)$',
                        },
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The DSL timeout in milliseconds',
                elementType: 'COMMON',
                id: 'dsl_time_out',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'DSL Timeout(ms)',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'WS Timeout(ms)',
                        defaultValue: '30000',
                        maxLength: 255,
                        minLength: 1,
                        pattern: {
                          value: '^(\\d+(\\.\\d+)?)$',
                        },
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The websocket timeout in milliseconds',
                elementType: 'COMMON',
                id: 'ws_time_out',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'WS Timeout(ms)',
              },
              {
                dataType: 'ENUM',
                definition: {
                  common: {
                    uiComponentOptions: {
                      select: {
                        isRequired: false,
                        label: 'Header Type',
                        choices: [
                          {
                            id: 1,
                            label: 'NONE',
                            order: 1,
                            value: 'NONE',
                          },
                          {
                            id: 2,
                            label: 'TPDU',
                            order: 2,
                            value: 'TPDU',
                          },
                          {
                            id: 3,
                            label: 'CLNP',
                            order: 3,
                            value: 'CLNP',
                          },
                        ],
                        defaultSelectedId: 1,
                      },
                    },
                    uiComponentType: 'SELECT',
                  },
                },
                description: 'The routing header prefixed to the message. Either no header, TPDU or CLNP headers.',
                elementType: 'COMMON',
                id: 'header_type',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Header Type',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Destination Address',
                        defaultValue: '',
                        maxLength: 10,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description:
                  'For TPDU header, 2 bytes hex string (e.g. NII 0001). For CLNP header, 5 bytes hex string (e.g. SHA 4982805110).',
                elementType: 'COMMON',
                id: 'destination_address',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Destination Address',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Source Address',
                        defaultValue: '',
                        maxLength: 10,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description:
                  'For TPDU header, 2 bytes hex string (e.g. 0002). For CLNP header, 5 bytes hex string (e.g. SPA 49009C4120).',
                elementType: 'COMMON',
                id: 'source_address',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Source Address',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'link_label',
          },
        },
        elementType: 'STRUCTURE',
        id: 'Links',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Links',
        containerId: '8c7f5a2e-454f-35f8-a662-e32b3a8cc4e0',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'DUKPT Initial Key Location',
                defaultValue: '',
                maxLength: 255,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'location where the dukpt initial key is stored',
        elementType: 'COMMON',
        id: 'dukpt_ik_location',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'DUKPT Initial Key Location',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'MK/SK Initial Key Location',
                defaultValue: '',
                maxLength: 255,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'location where the master key or session key is stored',
        elementType: 'COMMON',
        id: 'mksk_ik_location',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'MK/SK Initial Key Location',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Terminal Master Key Location',
                defaultValue: '',
                maxLength: 255,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'location where terminal master key is stored',
        elementType: 'COMMON',
        id: 'tmk_location',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Terminal Master Key Location',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Terminal Master Key Value',
                defaultValue: '',
                maxLength: 48,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Defines the terminal master key value',
        elementType: 'COMMON',
        id: 'tmk_value',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Terminal Master Key Value',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'STRING',
        definition: {
          common: {
            uiComponentOptions: {
              inputString: {
                isRequired: false,
                label: 'Terminal Master Key KCV',
                defaultValue: '',
                maxLength: 6,
                minLength: 1,
                type: 'TEXT',
              },
            },
            uiComponentType: 'INPUT',
          },
        },
        description: 'Defines the KCV used when injecting TMK',
        elementType: 'COMMON',
        id: 'tmk_kcv',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Terminal Master Key KCV',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Key System',
                choices: [
                  {
                    id: 1,
                    label: 'MKSK',
                    order: 1,
                    value: 'MKSK',
                  },
                  {
                    id: 2,
                    label: 'DUKPT',
                    order: 2,
                    value: 'DUKPT',
                  },
                  {
                    id: 3,
                    label: 'FIXED',
                    order: 3,
                    value: 'FIXED',
                  },
                ],
                defaultSelectedId: 2,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'kinds of key management scheme',
        elementType: 'COMMON',
        id: 'key_system',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Key System',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Key Algorithm',
                choices: [
                  {
                    id: 1,
                    label: 'TDES',
                    order: 1,
                    value: 'TDES',
                  },
                  {
                    id: 2,
                    label: 'AES_128',
                    order: 2,
                    value: 'AES_128',
                  },
                  {
                    id: 3,
                    label: 'AES_192',
                    order: 3,
                    value: 'AES_192',
                  },
                  {
                    id: 4,
                    label: 'AES_256',
                    order: 4,
                    value: 'AES_256',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'Key Algorithms value send, TDES: 01; AES_128: 02; AES_192: 03; AES_256: 04',
        elementType: 'COMMON',
        id: 'key_algorithm',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Key Algorithm',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Online PIN Block Format',
                choices: [
                  {
                    id: 1,
                    label: 'BLOCK_FORMAT_0',
                    order: 1,
                    value: 'BLOCK_FORMAT_0',
                  },
                  {
                    id: 2,
                    label: 'BLOCK_FORMAT_0_AS2805_6_2',
                    order: 2,
                    value: 'BLOCK_FORMAT_0_AS2805_6_2',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'To set the online PIN Block Format',
        elementType: 'COMMON',
        id: 'onlinepin_block_format',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Online PIN Block Format',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'ENUM',
        definition: {
          common: {
            uiComponentOptions: {
              select: {
                isRequired: false,
                label: 'Delay PIN Block',
                choices: [
                  {
                    id: 1,
                    label: 'Enabled',
                    order: 1,
                    value: 'true',
                  },
                  {
                    id: 2,
                    label: 'Disabled',
                    order: 2,
                    value: 'false',
                  },
                ],
                defaultSelectedId: 1,
              },
            },
            uiComponentType: 'SELECT',
          },
        },
        description: 'The delay pin block',
        elementType: 'COMMON',
        id: 'delay_pin_block',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Delay PIN Block',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
      {
        dataType: 'STRUCTURE',
        definition: {
          structure: {
            childFields: [
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'Label',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'The label to link with other tables',
                elementType: 'COMMON',
                id: 'session_key_label',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'Label',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'PIN Key Location',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Location of PIN session key (MK/SK)',
                elementType: 'COMMON',
                id: 'pin_key_location',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'PIN Key Location',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: false,
                        label: 'MAC Location',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description: 'Location of MAC session key (MK/SK)',
                elementType: 'COMMON',
                id: 'mac_key_location',
                isRequired: false,
                isTerminalModifiable: false,
                name: 'MAC Location',
              },
              {
                dataType: 'STRING',
                definition: {
                  common: {
                    uiComponentOptions: {
                      inputString: {
                        isRequired: true,
                        label: 'Batch Key Location',
                        defaultValue: '',
                        maxLength: 255,
                        minLength: 1,
                        type: 'TEXT',
                      },
                    },
                    uiComponentType: 'INPUT',
                  },
                },
                description:
                  'The location for the batch data encryption key. It must be unique per acquirer/host/batch. e.g. 0000 10, 0000 11, ...',
                elementType: 'COMMON',
                id: 'data_key_location',
                isRequired: true,
                isTerminalModifiable: false,
                name: 'Batch Key Location',
              },
            ],
            maxRows: 9999,
            uniqueKeys: 'session_key_label',
          },
        },
        elementType: 'STRUCTURE',
        id: 'SessionKey',
        isRequired: false,
        isTerminalModifiable: false,
        name: 'Session Key',
        containerId: '2fae3262-9d4e-34fc-a341-f1751b405e45',
      },
    ],
  },
};

export function getMockUpFormGeneratorTemplateByIdCustomHandler(
  context: ResponseResolverInfo<HttpRequestResolverExtras<PathParams>>,
) {
  return HttpResponse.json<TemplateDetailedResourceReadV2Api>(templateByIdPayload);
}

// eslint-disable-next-line max-lines-per-function
export function getTemplateByIdV2CustomHandler(context: ResponseResolverInfo<HttpRequestResolverExtras<PathParams>>) {
  const url = new URL(context.request.url);
  const { templateId } = context.params;
  return url.pathname.includes('d0e8e8e0-1b4d-4336-99b8-548e08b05666')
    ? HttpResponse.json<TemplateDetailedResourceReadV2Api>({
        checksum: '6666cc51d345e3c4f06cf26a4d25a15b71b75f6c6f2f80f1ed1b5a4fc282a777',
        componentType: 'APPLICATION',
        createdBy: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
        creationDate: new Date('2021-01-01T00:00:00Z'),
        extension: 'xml',
        fileName: 'template.xml',
        id: templateId as string,
        mimeType: 'application/zip',
        size: 102_400,
        type: 'TEMPLATE',
        description: 'Template for managing device configurations.',
        name: 'Simplified Template',
        targetLocation: 'SystemSettings/Configurations',
        templateFileId: 'simpleId',
        templateFileName: 'Device Configuration Template',
        templateFileVersion: 'v2.1',
        parameter: {
          containers: [
            {
              description: 'Description 1',
              id: 'd0e8e8e0-1b4d-4336-99b8-548e08b00555',
              name: 'Service info',
            },
          ],
          fields: [
            {
              dataType: 'STRING',
              definition: {
                common: {
                  uiComponentOptions: {
                    inputString: {
                      hint: 'Description hint',
                      isRequired: true,
                      label: 'Parameter1',
                      defaultValue: '',
                      maxLength: 200,
                      minLength: 1,
                      pattern: {
                        errorMessage: 'Error message',
                      },
                      placeholder: 'Parameter 1 placeholder',
                      type: 'TEXT',
                    },
                  },
                  uiComponentType: 'INPUT',
                },
              },
              description: 'Description for parameter 1',
              elementType: 'COMMON',
              id: 'service_self_managed',
              isRequired: true,
              name: 'Parameter1',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b00555',
            },
            {
              dataType: 'NUMBER',
              definition: {
                common: {
                  uiComponentOptions: {
                    inputNumber: {
                      hint: 'Number field',
                      isRequired: true,
                      label: 'Parameter2 Number',
                      defaultValue: 3,
                      max: 15,
                      min: 3,
                      placeholder: 'Parameter Number placeholder',
                    },
                  },
                  uiComponentType: 'INPUT',
                },
              },
              description: 'Description of a NUMBER',
              elementType: 'COMMON',
              id: 'Parameter_Number',
              isRequired: false,
              name: 'Number field',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b00555',
            },
            {
              dataType: 'BOOLEAN',
              definition: {
                common: {
                  uiComponentOptions: {
                    toggle: {
                      defaultValue: true,
                      hint: 'Is enabled',
                      label: 'Is enabled',
                    },
                  },
                  uiComponentType: 'TOGGLE',
                },
              },
              description: 'Toggle description',
              elementType: 'COMMON',
              id: 'service_enabled',
              isRequired: false,
              name: 'Is enabled',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b00555',
            },
            {
              dataType: 'STRING',
              definition: {
                common: {
                  uiComponentOptions: {
                    inputString: {
                      hint: 'Some description hint',
                      isRequired: false,
                      label: 'Parameter1 label',
                      defaultValue: '',
                      maxLength: 100,
                      minLength: 1,
                      pattern: {
                        errorMessage: 'Error message',
                      },
                      placeholder: 'Parameter 1 placeholder',
                      type: 'TEXT',
                    },
                  },
                  uiComponentType: 'INPUT',
                },
              },
              description: 'Some field description',
              elementType: 'COMMON',
              id: 'service_name',
              isRequired: true,
              name: 'Service Name',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b00555',
            },
          ],
        },
      })
    : HttpResponse.json<TemplateDetailedResourceReadV2Api>({
        checksum: '9c56cc51d345e3c4f06cf26a4d25a15b71b75f6c6f2f80f1ed1b5a4fc282a6f5',
        componentType: 'APPLICATION',
        createdBy: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
        creationDate: new Date('2021-01-01T00:00:00Z'),
        description: 'Template for managing device configurations.',
        extension: 'xml',
        fileName: 'template.xml',
        id: templateId as string,
        mimeType: 'application/zip',
        name: 'Device Configuration Template',
        size: 102_400,
        targetLocation: 'SystemSettings/Configurations',
        templateFileId: 'simpleId',
        templateFileName: 'Device Configuration Template',
        templateFileVersion: 'v2.1',
        type: 'TEMPLATE',
        parameter: {
          containers: [
            {
              description: 'Description 1',
              id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
              name: 'Tab1',
            },
            {
              description: 'Description 2',
              id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05803',
              name: 'Tab2',
            },
            {
              description: 'Description 3',
              id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05804',
              name: 'Tab3',
            },
          ],
          fields: [
            {
              dataType: 'ENUM',
              definition: {
                dynamicChoice: {
                  fieldId: 'Services',
                  fieldLabelId: 'service_name',
                  fieldValueId: 'service_name',
                },
              },
              description: 'dynamic field description',
              elementType: 'DYNAMIC_CHOICE',
              id: 'dynamic_choices_tab1',
              isRequired: false,
              name: 'Dynamic Choice',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
            },
            {
              dataType: 'ENUM',
              definition: {
                common: {
                  uiComponentOptions: {
                    multiSelect: {
                      defaultSelectedIds: [],
                      hint: 'HINT multi select service choice',
                      isRequired: false,
                      label: 'service choice label',
                      choices: [
                        {
                          id: 1,
                          label: 'Choice 1',
                          order: 1,
                          value: 'CHOICE_1',
                        },
                        {
                          id: 2,
                          label: 'Choice 2',
                          order: 2,
                          value: 'CHOICE_2',
                        },
                        {
                          id: 3,
                          label: 'Choice 3',
                          order: 3,
                          value: 'CHOICE_3',
                        },
                      ],
                      placeholder: 'service choice placeholder',
                    },
                  },
                  uiComponentType: 'MULTI_SELECT',
                },
              },
              description: 'Multi select description',
              elementType: 'COMMON',
              id: 'service_choices_tab1',
              isRequired: false,
              name: 'Service Choices Tab1',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
            },
            {
              dataType: 'ENUM',
              definition: {
                common: {
                  uiComponentOptions: {
                    select: {
                      hint: 'HINT select service type',
                      isRequired: false,
                      label: 'service type label',
                      choices: [
                        {
                          id: 1,
                          label: 'CUSTOMER_PRESENT',
                          order: 1,
                          value: 'CUSTOMER_PRESENT',
                        },
                        {
                          id: 2,
                          label: 'CUSTOMER_NOT_PRESENT',
                          order: 2,
                          value: 'CUSTOMER__NOTPRESENT',
                        },
                      ],
                      placeholder: 'service type placeholder',
                    },
                  },
                  uiComponentType: 'SELECT',
                },
              },
              description: 'mockedDescription',
              elementType: 'COMMON',
              id: 'service_type_tab1',
              isRequired: false,
              name: 'Service Type',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
            },
            {
              dataType: 'STRING',
              definition: {
                common: {
                  uiComponentOptions: {
                    inputString: {
                      hint: 'Description hint',
                      isRequired: false,
                      label: 'Parameter1 label',
                      defaultValue: '',
                      maxLength: 200,
                      minLength: 1,
                      pattern: {
                        errorMessage: 'Error message',
                        value: '^[^é]*$',
                      },
                      placeholder: 'Parameter 1 placeholder',
                      type: 'TEXT',
                    },
                  },
                  uiComponentType: 'INPUT',
                },
              },
              description: 'Description for parameter 1',
              elementType: 'COMMON',
              id: 'Parameter_1',
              isRequired: false,
              name: 'Parameter 1',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
            },
            {
              dataType: 'NUMBER',
              definition: {
                common: {
                  uiComponentOptions: {
                    inputNumber: {
                      hint: 'Description hint 2',
                      isRequired: true,
                      label: 'Parameter2 label',
                      defaultValue: 3,
                      max: 5,
                      min: 1,
                      placeholder: 'Parameter 2 placeholder',
                    },
                  },
                  uiComponentType: 'INPUT',
                },
              },
              description: 'Description for parameter 2',
              elementType: 'COMMON',
              id: 'Parameter_2',
              isRequired: true,
              name: 'Parameter 2',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
            },
            {
              dataType: 'STRUCTURE',
              definition: {
                structure: {
                  childFields: [
                    {
                      dataType: 'STRING',
                      definition: {
                        common: {
                          uiComponentOptions: {
                            inputString: {
                              hint: 'Description hint',
                              isRequired: true,
                              label: 'service name label',
                              defaultValue: '',
                              maxLength: 200,
                              minLength: 1,
                              pattern: {
                                errorMessage: 'Error message',
                                value: '^[^é]*$',
                              },
                              placeholder: 'service name placeholder',
                              type: 'TEXT',
                            },
                          },
                          uiComponentType: 'INPUT',
                        },
                      },
                      description: 'mockedDescription',
                      elementType: 'COMMON',
                      id: 'service_name',
                      isRequired: false,
                      name: 'Service Name',
                    },
                    {
                      dataType: 'ENUM',
                      definition: {
                        common: {
                          uiComponentOptions: {
                            select: {
                              hint: 'HINT select service type',
                              isRequired: false,
                              label: 'service type label',
                              choices: [
                                {
                                  id: 1,
                                  label: 'CUSTOMER_PRESENT',
                                  order: 1,
                                  value: 'CUSTOMER_PRESENT',
                                },
                                {
                                  id: 2,
                                  label: 'CUSTOMER_NOT_PRESENT',
                                  order: 2,
                                  value: 'CUSTOMER__NOTPRESENT',
                                },
                              ],
                              placeholder: 'service type placeholder',
                            },
                          },
                          uiComponentType: 'SELECT',
                        },
                      },
                      description: 'mockedDescription',
                      elementType: 'COMMON',
                      id: 'service_type',
                      isRequired: false,
                      name: 'Service Type',
                    },
                  ],
                },
              },
              description: 'Description for parameter structure Services',
              elementType: 'STRUCTURE',
              id: 'Services',
              isRequired: true,
              name: 'Services',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05803',
            },
            {
              dataType: 'STRUCTURE',
              definition: {
                structure: {
                  childFields: [
                    {
                      dataType: 'STRING',
                      definition: {
                        common: {
                          uiComponentOptions: {
                            inputString: {
                              hint: 'Description hint connection name',
                              isRequired: true,
                              label: 'connection name label',
                              defaultValue: '',
                              pattern: {
                                errorMessage: 'Error message',
                                value: '^[^é]*$',
                              },
                              placeholder: 'connection name placeholder',
                              type: 'TEXT',
                            },
                          },
                          uiComponentType: 'INPUT',
                        },
                      },
                      description: 'mockedDescription',
                      elementType: 'COMMON',
                      id: 'connection_name',
                      isRequired: true,
                      name: 'Connection Name',
                    },
                    {
                      dataType: 'STRUCTURE',
                      definition: {
                        structure: {
                          childFields: [
                            {
                              dataType: 'STRING',
                              definition: {
                                common: {
                                  uiComponentOptions: {
                                    inputString: {
                                      hint: 'Description hint test_name_1',
                                      isRequired: true,
                                      label: 'test_name_1 label',
                                      defaultValue: '',
                                      placeholder: 'test_name_1 placeholder',
                                      type: 'TEXT',
                                    },
                                  },
                                  uiComponentType: 'INPUT',
                                },
                              },
                              description: 'mockedDescription',
                              elementType: 'COMMON',
                              id: 'test_name_1',
                              isRequired: false,
                              name: 'Test Name 1',
                            },
                            {
                              dataType: 'STRING',
                              definition: {
                                common: {
                                  uiComponentOptions: {
                                    inputString: {
                                      hint: 'Description hint test_name_2',
                                      isRequired: true,
                                      label: 'test name 2 label',
                                      defaultValue: '',
                                      maxLength: 200,
                                      minLength: 1,
                                      pattern: {
                                        errorMessage: 'Error message',
                                        value: '^[^é]*$',
                                      },
                                      placeholder: 'test_name_2 placeholder',
                                      type: 'TEXT',
                                    },
                                  },
                                  uiComponentType: 'INPUT',
                                },
                              },
                              description: 'mockedDescription',
                              elementType: 'COMMON',
                              id: 'test_name_2',
                              isRequired: true,
                              name: 'Test Name 2',
                            },
                          ],
                        },
                      },
                      description: 'Description for parameter structure RefECRLink',
                      elementType: 'STRUCTURE',
                      id: 'RefECRLink',
                      isRequired: true,
                      name: 'Ref ECR Link',
                    },
                  ],
                },
              },
              description: 'Description for parameter structure EcrConnectionConfig',
              elementType: 'STRUCTURE',
              id: 'EcrConnectionConfig',
              isRequired: true,
              name: 'Ecr Connection Config',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05804',
            },
            {
              dataType: 'ENUM',
              definition: {
                common: {
                  uiComponentOptions: {
                    multiSelect: {
                      defaultSelectedIds: [],
                      hint: 'HINT multi select service choice',
                      isRequired: false,
                      label: 'service choice label',
                      choices: [
                        {
                          id: 1,
                          label: 'Choice 1',
                          order: 1,
                          value: 'CHOICE_1',
                        },
                        {
                          id: 2,
                          label: 'Choice 2',
                          order: 2,
                          value: 'CHOICE_2',
                        },
                        {
                          id: 3,
                          label: 'Choice 3',
                          order: 3,
                          value: 'CHOICE_3',
                        },
                      ],
                      placeholder: 'service choice placeholder',
                    },
                  },
                  uiComponentType: 'MULTI_SELECT',
                },
              },
              description: 'Multi select description',
              elementType: 'COMMON',
              id: 'service_choices',
              isRequired: false,
              name: 'Service Choices',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
            },
            {
              dataType: 'ENUM',
              definition: {
                common: {
                  uiComponentOptions: {
                    select: {
                      hint: 'HINT select test choice',
                      isRequired: false,
                      label: 'test choice label',
                      choices: [
                        {
                          id: 1,
                          label: 'Choice 1',
                          order: 1,
                          value: 'CHOICE_1',
                        },
                        {
                          id: 2,
                          label: 'Choice 2',
                          order: 2,
                          value: 'CHOICE_2',
                        },
                        {
                          id: 3,
                          label: 'Choice 3',
                          order: 3,
                          value: 'CHOICE_3',
                        },
                      ],
                      placeholder: 'Test choice placeholder',
                    },
                  },
                  uiComponentType: 'SELECT',
                },
              },
              description: 'Select description',
              elementType: 'COMMON',
              id: 'test_choices',
              isRequired: false,
              name: 'Test Choices',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05802',
            },
            {
              dataType: 'BOOLEAN',
              definition: {
                common: {
                  uiComponentOptions: {
                    toggle: {
                      defaultValue: true,
                      hint: 'Toggle hint',
                      label: 'Toggle label',
                    },
                  },
                  uiComponentType: 'TOGGLE',
                },
              },
              description: 'Toggle description',
              elementType: 'COMMON',
              id: 'service_toggle',
              isRequired: true,
              name: 'Service Toggle',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05803',
            },
            {
              dataType: 'STRING',
              definition: {
                common: {
                  uiComponentOptions: {
                    dateTime: {
                      hint: 'Date time hint',
                      isRequired: true,
                      label: 'Date time label',
                      endDate: new Date('2025-05-16T00:00:00Z'),
                      format: 'YYYY-MM-DD HH:mm:ss',
                      startDate: new Date('2025-05-20T03:00:00Z'),
                      type: 'DATE_TIME',
                    },
                  },
                  uiComponentType: 'DATE_TIME',
                },
              },
              description: 'Date time description',
              elementType: 'COMMON',
              id: 'service_date_time',
              isRequired: true,
              name: 'Service Date Time',
              containerId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05804',
            },
          ],
        },
      });
}
